import React from 'react'
import { TextField } from '@material-ui/core'

import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'

export default function CustomDatePicker(props) {
  const { startDate, setStartDate } = props

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <DatePicker
        value={startDate}
        onChange={(val) => {
          setStartDate(val)
        }}
        inputVariant="outlined"
        format="dd/MM/yyyy"
        size="small"
        renderInput={(params) => <TextField {...params} />}
        {...props}
      />
    </MuiPickersUtilsProvider>
  )
}
